import { TreeNode } from '../../hooks/stores/launcherElementsStore';

export const cleanTree = (treeData: TreeNode[], accessor: (node: TreeNode) => TreeNode[]) => {
  return treeData.map((node) => {
    const cleanedNode: TreeNode = { id: node.id };

    let children: TreeNode[] | undefined;

    if (typeof accessor === 'function') {
      const accessorResult = accessor(node);
      children = accessorResult?.length > 0 ? cleanTree(accessorResult, accessor) : accessorResult;
    }
    cleanedNode.children = children;

    return cleanedNode;
  });
};
